import './Legal.css'

function Legal() {
  return (
    <div className='legal'>
        <p className='politica'> C.G.V - C.G.U - Menciones legales - Política de privacidad y cookies - FAQ - Ayuda/ Contacto - Tiendas Decathlon </p>
        <p> * Consulta los métodos, plazos y gastos de envio disponibles en el siguiente <a href="#"> enlace </a>. </p>
        <p> **Los precios de venta de los artículos de nuestro catálogo incluyen IVA.  Los precios para las 
        entregas con destino a Canarias, Ceuta, Melilla y Andorra incluyen impuestos indirectos.  Los precios 
        de venta de los artículos de nuestro catálogo son los recomendados, </p>
        <p> desde central a dia de ayer. Gastos de envío no incluidos.  Fotos de los productos no contractuales. </p>
    </div>
  );
}

export default Legal;